import React from "react";
import { fileUrl } from "../lib/api";
import { ImageIcon } from "lucide-react";

export default function ProductImage({ path, alt, className = "", size = 48 }) {
  if (!path) {
    return (
      <div
        className={`flex items-center justify-center bg-stone-100 border border-stone-200 rounded-md ${className}`}
        style={{ width: size, height: size }}
      >
        <ImageIcon className="w-4 h-4 text-stone-400" />
      </div>
    );
  }
  const src = fileUrl(path);
  return (
    <img
      src={src}
      alt={alt || ""}
      className={`object-cover rounded-md border border-stone-200 ${className}`}
      style={{ width: size, height: size }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  );
}
